import { Close } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";
import { SchemaComponentForm } from "../../../FollowUps/followup-form/modules/DynamicSection/components/SchemaComponentForm";
import { serviceCardSx } from "../styles";

const NewService = ({ serviceForm, flatSchema, onChange, onRemove, onCommit }) => {
  const handleRemove = () => {
    onRemove();
  };

  return (
    <>
      <Box sx={{ ...serviceCardSx, mt: 0.5, mb: 0.5 }}>
        <SchemaComponentForm
          schema={flatSchema}
          data={serviceForm}
          commitOnBlurOnly
          onCommit={(finalForm) => (onCommit ? onCommit(finalForm) : onChange(finalForm))}
        />
        <IconButton
          data-skip-blur-commit="true"
          sx={{ color: HNSColors.failure[500], mt: 4, ml: 2 }}
          onClick={handleRemove}
        >
          <Close sx={{ fontSize: 36 }} />
        </IconButton>
      </Box>
    </>
  );
};

export default NewService;
